// extracted by mini-css-extract-plugin
export default {"required-label":"SecondaryRequiredLabel_required-label__V6OrF","required-label-text":"SecondaryRequiredLabel_required-label-text__EOshN"};